import React from 'react'
import { connect } from 'react-redux'

const mapStateToProps = (state) => {
    const { nav } = state
    return {
        navTheme: nav.navTheme
    }
}


const NavActions = ({ setActiveChapterIndex, activeChapter, chapterLength, lastChapter, navTheme }) => {
    // lastChapter lets callers drop the trailing wrap-up slide; defaults to chapterLength + 1
    const lastIndex = lastChapter ?? chapterLength + 1
    return (
        <div className={`nav-actions ${navTheme}`}>
            <button className={`previous ${activeChapter === 1 ? 'disabled' : ''} ${activeChapter >= lastIndex ? 'active' : ''}`} onClick={() => setActiveChapterIndex(activeChapter - 1)}>
                Prev
            </button>
            <button className={`next ${activeChapter >= lastIndex ? 'disabled' : ''}`} onClick={() => setActiveChapterIndex(activeChapter + 1)}>
                Next
            </button>
            <div className="page-counter">
                {activeChapter} / {lastIndex}
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(NavActions)
